"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SearchBreadcrumbs;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _icon = require("@site/pattern-library-utils/icon");
const BreadcrumbsList = /*#__PURE__*/(0, _react2.styled)("ol")({
  name: "BreadcrumbsList",
  class: "pl-b1b0lr0v"
});
function Crumb({
  list,
  index,
  crumbUrl,
  label,
  resultsExternalPaths,
  crumbPrefix
}) {
  const urlTarget = resultsExternalPaths?.some(path => crumbUrl?.includes(path)) ? '_blank' : '_self';
  const trackingProps = _patternLibraryUtils.tracking.create(`${crumbPrefix}_${label}_crumb`, true, false);
  if (list.length > 3 && index === 1) {
    return /*#__PURE__*/_react.default.createElement("li", {
      "data-cy": "crumb"
    }, "\u2026", index < list.length - 1 && /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "chevron-right",
      width: "18",
      height: "18"
    }));
  }
  return /*#__PURE__*/_react.default.createElement("li", {
    "data-cy": "crumb"
  }, /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    href: crumbUrl,
    target: urlTarget
  }, trackingProps), label), index < list.length - 1 && /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-right",
    width: "18",
    height: "18"
  }));
}
Crumb.propTypes = {
  list: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })).isRequired,
  resultsExternalPaths: _propTypes.default.arrayOf(_propTypes.default.string),
  crumbPrefix: _propTypes.default.string,
  crumbUrl: _propTypes.default.string,
  label: _propTypes.default.string,
  index: _propTypes.default.number
};
function SearchBreadcrumbs({
  breadcrumbs,
  resultsExternalPaths,
  searchTerm,
  resultTitle
}) {
  const crumbPrefix = `${searchTerm}_${resultTitle}`.replace(/ /g, '_');
  return /*#__PURE__*/_react.default.createElement(BreadcrumbsList, {
    "data-cy": "breadcrumbs"
  }, breadcrumbs?.map(({
    label,
    url: crumbUrl
  }, i) => /*#__PURE__*/_react.default.createElement(Crumb, {
    list: breadcrumbs,
    key: i,
    index: i,
    crumbUrl: crumbUrl,
    label: label,
    crumbPrefix: crumbPrefix,
    resultsExternalPaths: resultsExternalPaths
  })));
}
SearchBreadcrumbs.propTypes = {
  breadcrumbs: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })).isRequired,
  resultsExternalPaths: _propTypes.default.arrayOf(_propTypes.default.string),
  searchTerm: _propTypes.default.string,
  resultTitle: _propTypes.default.string
};